const customerProfileGraphqlQuery = `
    query {
        customerProfile  {
            __typename
            ... on CustomerResponse {
                customer { 
                    accountNumber
                    address { 
                        addressLine1
                        addressLine2
                        city
                        country
                        addressType
                        countryCode
                        postalCode
                        rawAddress
                        stateCode
                        stateName
                        type
                        fullAddress
                        streetNumber
                        postalType
                        postalNumber
                        buildingName
                        subdwelling
                        attributes { 
                            CountryIso2
                            CountryIso3
                            City
                            DomesticId
                            DataLevel
                            ProvinceName
                            Type
                            Language
                            SortingNumber1
                            LanguageAlternatives
                            Barcode
                            ProvinceCode
                            CountryIsoNumber
                            Neighbourhood
                            AdminAreaName
                            Company
                            Line1
                            Line2
                            Line3
                            Line4
                        }
                        id
                        district
                        province
                        permanentAddress { 
                            addressLine1
                            addressLine2
                            city
                            country
                            addressType
                            countryCode
                            postalCode
                            rawAddress
                            stateCode
                            stateName
                            type
                            fullAddress
                            streetNumber
                            postalType
                            postalNumber
                            buildingName
                            subdwelling
                            attributes { 
                                CountryIso2
                                CountryIso3
                                City
                                DomesticId
                                DataLevel
                                ProvinceName
                                Type
                                Language
                                SortingNumber1
                                LanguageAlternatives
                                Barcode
                                ProvinceCode
                                CountryIsoNumber
                                Neighbourhood
                                AdminAreaName
                                Company
                                Line1
                                Line2
                                Line3
                                Line4
                            }
                            id
                            district
                            province
                            permanentAddress { 
                                addressLine1
                                addressLine2
                                city
                                country
                                addressType
                                countryCode
                                postalCode
                                rawAddress
                                stateCode
                                stateName
                                type
                                fullAddress
                                streetNumber
                                postalType
                                postalNumber
                                buildingName
                                subdwelling
                                id
                                district
                                province
                                streetLine1
                                streetLine2
                                cityTown
                                stateProvince
                                zipPostalCode
                                state
                            }
                            addressVerification { 
                                status
                                statusBy
                                updatedDate
                                expiryDate
                                pin
                            }
                            streetLine1
                            streetLine2
                            cityTown
                            stateProvince
                            zipPostalCode
                            state
                        }
                        addressVerification { 
                            status
                            statusBy
                            updatedDate
                            expiryDate
                            pin
                        }
                        streetLine1
                        streetLine2
                        cityTown
                        stateProvince
                        zipPostalCode
                        state
                    }
                    complianceData { 
                        comments
                        complianceType
                        cuba
                        docReceived
                        documents { 
                            birthPlace
                            cardRefNumber
                            dmsReferenceNumber
                            paDmsReferenceNumber
                            dobMatch
                            docLevel
                            docName
                            docNumber
                            docNumberMatch
                            docSubType
                            docType
                            docVerificationStatus
                            expirationDate
                            expired
                            isExpired
                            isPrimary
                            familyName
                            idType
                            idvvApprovedTs
                            idvvStatus
                            iso2Code
                            issueAgency
                            issueAuthority
                            issueCountry
                            issueDate
                            issuePlace
                            issueState
                            issuer
                            mrzCode
                            ocrCode
                            ocrFormStatus
                            primary
                            verificationApprovedTime
                            idvvSubStatus
                            attachedDocuments { 
                                binary
                                imageUrl
                                fileName
                                format
                                pageNum
                                rotationDegree
                                imageBinary
                            }
                            vendorRefNumber
                            imageProcessedFront
                            isDocActive
                            workflowId
                            accountId
                            kycFormStatus
                            retailVerifiedFlag
                            lastUpdated
                            channelType
                        }
                        employerName
                        identityVerificationStatus
                        maritalStatus
                        pepCategory
                        pepRelation
                        personalIdentificationNumber
                        verifications { 
                            lastUpdated
                            status
                            type
                        }
                        version
                        addressVerified
                        addressVerificationDocName
                        addressVerificationDocType
                        addressVerificationDocNumber
                        addressVerificationDocIssuer
                        addressVerificationDocIssueDate
                        kycConsentFlag
                        cubaQuestions { 
                            affidavitType
                            question1
                            question2
                            question3
                            question4
                            question5
                            question6
                            question7
                            question8
                            question9
                            question10
                            question11
                            question12
                            question13
                            question14
                            question15
                            question16
                            question17
                            question18
                            question19
                        }
                    }
                    complianceVerificationDetail { 
                        channelType
                        status
                        type
                    }
                    countryOfBirth
                    credential { 
                        password
                        securityQuestions { 
                            answer
                            question
                        }
                    }
                    customerInWallet
                    customerLevelCode
                    customerType
                    dateOfBirth
                    email
                    employment { 
                        industry
                        level
                        name
                        status
                    }
                    flowName
                    galacticId
                    galacticIdUpdatedDate
                    gender
                    id
                    imageUrl
                    myWuMemberFlag
                    name { 
                        first
                        middle
                        last
                        secondLast
                        nameType
                        maternal
                        paternal
                        prefix
                        suffix
                        givenName
                        firstName
                        lastName
                        displayName
                        paternalName
                        maternalName
                        companyName
                        attentionCodeCity
                    }
                    nameMatchIndicator
                    nationality
                    newPointsEarned
                    notification { 
                        email
                        featureEnable
                        mail
                        marketing
                        optInShape
                        optInShare
                        optInPartnerOffers
                        phone
                        sms
                        thirdPartyDataConsent
                        thirdpartyDatasharingConsent
                        prefLanguageCode
                    }
                    occupation
                    payment { 
                        banks { 
                            accHolderName { 
                                first
                                middle
                                last
                                secondLast
                                nameType
                                maternal
                                paternal
                                prefix
                                suffix
                                givenName
                                firstName
                                lastName
                                displayName
                                paternalName
                                maternalName
                                companyName
                                attentionCodeCity
                            }
                            accountNumber
                            accountType
                            nationalIdentificationNumber
                            address { 
                                addressLine1
                                addressLine2
                                city
                                country
                                addressType
                                countryCode
                                postalCode
                                rawAddress
                                stateCode
                                stateName
                                type
                                fullAddress
                                streetNumber
                                postalType
                                postalNumber
                                buildingName
                                subdwelling
                                id
                                district
                                province
                                streetLine1
                                streetLine2
                                cityTown
                                stateProvince
                                zipPostalCode
                                state
                            }
                            bankLocation
                            branchCode
                            code
                            currencyCode
                            financialId
                            id
                            name
                            network
                            nickName
                            paymentInstrumentId
                            prefix
                            reason
                            routingNumber
                            selectedAccountType
                            sortCode
                            suffix
                            swiftCode
                            type
                            upiId
                            accessToken
                            itemId
                            pwmbInfo { 
                                pwmbAccountDigest
                                accessId
                                merchantId
                                merchantReference
                                signature
                                pwmbResponse
                                pwmbTransactionId
                            }
                        }
                        cards { 
                            address { 
                                addressLine1
                                addressLine2
                                city
                                country
                                addressType
                                countryCode
                                postalCode
                                rawAddress
                                stateCode
                                stateName
                                type
                                fullAddress
                                streetNumber
                                postalType
                                postalNumber
                                buildingName
                                subdwelling
                                id
                                district
                                province
                                streetLine1
                                streetLine2
                                cityTown
                                stateProvince
                                zipPostalCode
                                state
                            }
                            bin
                            cardScanned
                            category
                            consent
                            consentRefId
                            currency
                            digest
                            doZda
                            expirationDate
                            id
                            jumio
                            name { 
                                first
                                middle
                                last
                                secondLast
                                nameType
                                maternal
                                paternal
                                prefix
                                suffix
                                givenName
                                firstName
                                lastName
                                displayName
                                paternalName
                                maternalName
                                companyName
                                attentionCodeCity
                            }
                            nickName
                            number
                            paymentInstrumentId
                            reason
                            type
                            suggestedCountry
                        }
                        wallets { 
                            currency
                            reason
                            serviceProviderCode
                            serviceProviderName
                            walletAccountNumber
                        }
                        wuPay { 
                            referenceNumber
                            gmoBranchCode
                            gmoBranchName
                        }
                    }
                    phoneNumber { 
                        countryCode
                        number
                        type
                        isVerified
                        phoneType
                        phoneNumber
                    }
                    placeOfBirth
                    pointsEarned
                    progressiveRegistration
                    receiverDigest
                    receiverNumber
                    receiverType
                    registrationDate
                    registrationStatus
                    stateOfBirth
                    termsConditions
                    type
                    uid
                    validationRequired
                    optInReferAFriendFlag
                    imageBinary
                    relationshipToSender
                    emailVerificationStatus
                    consumerToBusinessName
                    consumerToBusinessReference
                    isResident
                    annualIncome
                    annualIncomeCurrency
                    annualIncomeBracket
                    subscriptions { 
                        campaignName
                        endDate
                        subscriptionId
                    }
                    receiverNationalId
                    consumerToBusiness { 
                        name
                        reference
                    }
                    partner { 
                        name
                        terminalId
                        partnerId
                    }
                    lastUpdateTimeStamp
                    captcha { 
                        answer
                        clearScreen
                        image
                        sound
                        recaptcha
                    }
                    umnHash
                    profileReconfirmation
                    debitCardToken
                    permanentCountry
                    kycNotification { 
                        kycNotificationMethod
                        kycNotificationValue { 
                            email
                            phone
                        }
                        kycNotificationVendor
                    }
                    referralDetails { 
                        referralCode
                        referralSite
                    }
                    referenceId
                    customerDigest
                    updateSenderAssociateFlag
                }
                receiver { 
                    billers { 
                        accountNumber
                        accountRequired
                        activeFlag
                        billerName
                        billerType
                        category
                        code
                        contracted
                        countryIsoCode
                        currencyIsoCode
                        fraudWarningConsentRequired
                        groupByBiller
                        id
                        industry
                        language
                        preConfig
                        prePaid
                        template
                        uid
                    }
                    customers { 
                        accountNumber
                        address { 
                            addressLine1
                            addressLine2
                            city
                            country
                            addressType
                            countryCode
                            postalCode
                            rawAddress
                            stateCode
                            stateName
                            type
                            fullAddress
                            streetNumber
                            postalType
                            postalNumber
                            buildingName
                            subdwelling
                            attributes { 
                                CountryIso2
                                CountryIso3
                                City
                                DomesticId
                                DataLevel
                                ProvinceName
                                Type
                                Language
                                SortingNumber1
                                LanguageAlternatives
                                Barcode
                                ProvinceCode
                                CountryIsoNumber
                                Neighbourhood
                                AdminAreaName
                                Company
                                Line1
                                Line2
                                Line3
                                Line4
                            }
                            id
                            district
                            province
                            permanentAddress { 
                                addressLine1
                                addressLine2
                                city
                                country
                                addressType
                                countryCode
                                postalCode
                                rawAddress
                                stateCode
                                stateName
                                type
                                fullAddress
                                streetNumber
                                postalType
                                postalNumber
                                buildingName
                                subdwelling
                                id
                                district
                                province
                                streetLine1
                                streetLine2
                                cityTown
                                stateProvince
                                zipPostalCode
                                state
                            }
                            addressVerification { 
                                status
                                statusBy
                                updatedDate
                                expiryDate
                                pin
                            }
                            streetLine1
                            streetLine2
                            cityTown
                            stateProvince
                            zipPostalCode
                            state
                        }
                        complianceData { 
                            comments
                            complianceType
                            cuba
                            docReceived
                            documents { 
                                birthPlace
                                cardRefNumber
                                dmsReferenceNumber
                                paDmsReferenceNumber
                                dobMatch
                                docLevel
                                docName
                                docNumber
                                docNumberMatch
                                docSubType
                                docType
                                docVerificationStatus
                                expirationDate
                                expired
                                isExpired
                                isPrimary
                                familyName
                                idType
                                idvvApprovedTs
                                idvvStatus
                                iso2Code
                                issueAgency
                                issueAuthority
                                issueCountry
                                issueDate
                                issuePlace
                                issueState
                                issuer
                                mrzCode
                                ocrCode
                                ocrFormStatus
                                primary
                                verificationApprovedTime
                                idvvSubStatus
                                vendorRefNumber
                                imageProcessedFront
                                isDocActive
                                workflowId
                                accountId
                                kycFormStatus
                                retailVerifiedFlag
                                lastUpdated
                                channelType
                            }
                            employerName
                            identityVerificationStatus
                            maritalStatus
                            pepCategory
                            pepRelation
                            personalIdentificationNumber
                            verifications { 
                                lastUpdated
                                status
                                type
                            }
                            version
                            addressVerified
                            addressVerificationDocName
                            addressVerificationDocType
                            addressVerificationDocNumber
                            addressVerificationDocIssuer
                            addressVerificationDocIssueDate
                            kycConsentFlag
                            cubaQuestions { 
                                affidavitType
                                question1
                                question2
                                question3
                                question4
                                question5
                                question6
                                question7
                                question8
                                question9
                                question10
                                question11
                                question12
                                question13
                                question14
                                question15
                                question16
                                question17
                                question18
                                question19
                            }
                        }
                        complianceVerificationDetail { 
                            channelType
                            status
                            type
                        }
                        countryOfBirth
                        credential { 
                            password
                            securityQuestions { 
                                answer
                                question
                            }
                        }
                        customerInWallet
                        customerLevelCode
                        customerType
                        dateOfBirth
                        email
                        employment { 
                            industry
                            level
                            name
                            status
                        }
                        flowName
                        galacticId
                        galacticIdUpdatedDate
                        gender
                        id
                        imageUrl
                        myWuMemberFlag
                        name { 
                            first
                            middle
                            last
                            secondLast
                            nameType
                            maternal
                            paternal
                            prefix
                            suffix
                            givenName
                            firstName
                            lastName
                            displayName
                            paternalName
                            maternalName
                            companyName
                            attentionCodeCity
                        }
                        nameMatchIndicator
                        nationality
                        newPointsEarned
                        notification { 
                            email
                            featureEnable
                            mail
                            marketing
                            optInShape
                            optInShare
                            optInPartnerOffers
                            phone
                            sms
                            thirdPartyDataConsent
                            thirdpartyDatasharingConsent
                            prefLanguageCode
                        }
                        occupation
                        payment { 
                            banks { 
                                accountNumber
                                accountType
                                nationalIdentificationNumber
                                bankLocation
                                branchCode
                                code
                                currencyCode
                                financialId
                                id
                                name
                                network
                                nickName
                                paymentInstrumentId
                                prefix
                                reason
                                routingNumber
                                selectedAccountType
                                sortCode
                                suffix
                                swiftCode
                                type
                                upiId
                                accessToken
                                itemId
                            }
                            cards { 
                                bin
                                cardScanned
                                category
                                consent
                                consentRefId
                                currency
                                digest
                                doZda
                                expirationDate
                                id
                                jumio
                                nickName
                                number
                                paymentInstrumentId
                                reason
                                type
                                suggestedCountry
                            }
                            wallets { 
                                currency
                                reason
                                serviceProviderCode
                                serviceProviderName
                                walletAccountNumber
                            }
                            wuPay { 
                                referenceNumber
                                gmoBranchCode
                                gmoBranchName
                            }
                        }
                        phoneNumber { 
                            countryCode
                            number
                            type
                            isVerified
                            phoneType
                            phoneNumber
                        }
                        placeOfBirth
                        pointsEarned
                        progressiveRegistration
                        receiverDigest
                        receiverNumber
                        receiverType
                        registrationDate
                        registrationStatus
                        stateOfBirth
                        termsConditions
                        type
                        uid
                        validationRequired
                        optInReferAFriendFlag
                        imageBinary
                        relationshipToSender
                        emailVerificationStatus
                        consumerToBusinessName
                        consumerToBusinessReference
                        isResident
                        annualIncome
                        annualIncomeCurrency
                        annualIncomeBracket
                        subscriptions { 
                            campaignName
                            endDate
                            subscriptionId
                        }
                        receiverNationalId
                        consumerToBusiness { 
                            name
                            reference
                        }
                        partner { 
                            name
                            terminalId
                            partnerId
                        }
                        lastUpdateTimeStamp
                        captcha { 
                            answer
                            clearScreen
                            image
                            sound
                            recaptcha
                        }
                        umnHash
                        profileReconfirmation
                        debitCardToken
                        permanentCountry
                        kycNotification { 
                            kycNotificationMethod
                            kycNotificationValue { 
                                email
                                phone
                            }
                            kycNotificationVendor
                        }
                        referralDetails { 
                            referralCode
                            referralSite
                        }
                        referenceId
                        customerDigest
                        updateSenderAssociateFlag
                    }
                }
                customerVerifyResponse { 
                    issues { 
                        field
                        code
                        issue
                    }
                    legacyError
                    errorCode
                    message
                    correlationId
                    name
                    priority
                }
                captcha { 
                    answer
                    clearScreen
                    image
                    sound
                    recaptcha
                }
            }
            ... on ErrorResponse {
                correlationId
                errorCode
                issues { 
                    field
                    issue
                    code
                    message
                }
                legacyError
                message
                name
                priority
                stack
            }
        }
    }`